import React from 'react';
import { X, Loader2 } from 'lucide-react';

const SuppliersListModal = ({ isOpen, onClose, suppliers = [], isLoading = false }) => {
  if (!isOpen) return null;

  // Helper function to format CO2 text with subscript
  const formatCO2 = (text) => {
    return text.replace('CO2e/t', 'CO<sub>2</sub>e/t');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] relative flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Alle Zulieferer</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="overflow-y-auto flex-grow">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin text-green-600 mb-2" />
              <p className="text-gray-700">Daten werden geladen...</p>
            </div>
          ) : (
            <div className="space-y-4">
              {suppliers.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-md">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden flex-shrink-0 border border-gray-200">
                      <img
                        src="/logos/BAG.png"
                        alt={item.name}
                        className="w-8 h-8 object-contain"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `/api/placeholder/32/32`;
                        }}
                      />
                    </div>
                    <div>
                      <div>
                        {(() => {
                          // Split postal code and city name
                          const match = item.name.match(/^(\d{5})\s+(.+)$/);
                          if (match) {
                            // If it matches the pattern "12345 City"
                            return (
                              <>
                                <div className="font-medium">{match[1]}</div>
                                <div className="font-medium">{match[2]}</div>
                              </>
                            );
                          } else {
                            return <div className="font-medium">{item.name}</div>;
                          }
                        })()}
                      </div>
                      <div className="text-sm text-green-600" dangerouslySetInnerHTML={{ __html: formatCO2(`${item.purchases} kg CO2e/t`) }} />
                    </div>
                  </div>
                  <div className="font-medium whitespace-nowrap">{item.amount}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuppliersListModal;
